import { GET } from '@/server/http';
import URLS from '@/server/urls';
export default async ({
  w = 120,
  h = 40
}, options = {
  showError: true
}) => {
  const [content, error, status] = await GET(URLS.common.verCodeImg, {
    w,
    h
  }, options);
  if (error) return {
    error,
    status
  };
  return content || {};
};